import React, { useRef, useEffect, useState } from 'react'

export const useDidUpdate = (callback, deps) => {
    const hasMount = useRef(false)

    useEffect(() => {
        if (hasMount.current) {
            callback()
        } else {
            hasMount.current = true
        }
    }, deps)
};


// WEBPACK FOOTER //
// ./src/Helpers/useDidUpdate.js